var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/blurhash.tsx";
const _excluded = ["hash", "width", "height", "dummy"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { decode } from 'blurhash';
import React, { useRef, useEffect } from 'react';

/**
 * Renders a blurhash in a canvas element.
 * @see {@link https://blurha.sh/}
 */
const Blurhash = _ref => {
  let {
    hash,
    width = 32,
    height = width,
    dummy = false
  } = _ref,
      canvasProps = _objectWithoutProperties(_ref, _excluded);

  const canvasRef = useRef(null);
  useEffect(() => {
    const {
      current: canvas
    } = canvasRef;
    if (!canvas) return; // resets canvas

    canvas.width = canvas.width; // eslint-disable-line no-self-assign

    if (dummy || !hash) return;

    try {
      const pixels = decode(hash, width, height);
      const ctx = canvas.getContext('2d');
      const imageData = new ImageData(pixels, width, height);
      if (!ctx) return;
      ctx.putImageData(imageData, 0, 0);
    } catch (err) {
      console.error('Blurhash decoding failure', {
        err,
        hash
      });
    }
  }, [dummy, hash, width, height]);
  return /*#__PURE__*/React.createElement("canvas", _extends({}, canvasProps, {
    ref: canvasRef,
    width: width,
    height: height,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 5
    }
  }));
};

export default /*#__PURE__*/React.memo(Blurhash);